import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const InsurancePolicy = ({ lineItems  })=>{
    const intl = useIntl();
    const labels = React.useMemo(()=>({
            policyNumber: intl.getLabel('products.insurance.policyNumber'),
            policyDurationTitle: intl.getLabel('products.insurance.duration.title'),
            policyDurationDescription: intl.getLabel('products.insurance.duration.text'),
            coverageIncludes: intl.getLabel('products.insurance.coverage.title'),
            uspList: [
                intl.getLabel('products.insurance.coverage.usp1', {
                    hideLabelKey: true
                }),
                intl.getLabel('products.insurance.coverage.usp2', {
                    hideLabelKey: true
                }),
                intl.getLabel('products.insurance.coverage.usp3', {
                    hideLabelKey: true
                }), 
            ].filter(Boolean),
            howToUseYourPolicy: intl.getLabel('products.insurance.policy.title'),
            howToUseYourPolicyDescription: intl.getLabel('products.insurance.policy.text'),
            policyDetailsTitle: intl.getLabel('products.insurance.link.title'),
            policyDetailsLink: intl.getFormattedLabel('products.insurance.link.text', {
                parseLink: true,
                openLinksInNewTab: true
            })
        })
    , [
        intl
    ]);
    return /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, lineItems === null || lineItems === void 0 ? void 0 : lineItems.map((lineItem, i)=>{
        var ref;
         return React.createElement(Card.Section, {
            key: `line-item-${i}`
        }, /*#__PURE__*/ React.createElement(Card.Heading, {
            variant: "subheading2",
            component: "h5"
        }, lineItem.title), ((ref = lineItem.insurance) === null || ref === void 0 ? void 0 : ref.policyNumber) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: "insurance-policy__number"
        }, /*#__PURE__*/ React.createElement(Card.Text, {
            variant: "body-head"
        }, labels.policyNumber), /*#__PURE__*/ React.createElement(Card.Text, null, "\xa0", lineItem.insurance.policyNumber)), /*#__PURE__*/ React.createElement("div", {
            className: "insurance-policy__duration"
        }, /*#__PURE__*/ React.createElement(Card.Text, {
            variant: "body-head"
        }, labels.policyDurationTitle), /*#__PURE__*/ React.createElement(Card.Text, null, "\xa0", labels.policyDurationDescription))));
    }), labels.uspList.length > 0 && /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Heading, {
        variant: "subheading2",
        component: "h5"
    }, labels.coverageIncludes), labels.uspList.map((uspItem, i)=>/*#__PURE__*/ React.createElement(Card.Text, {
            key: `usp-${i}`
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "checkmark"
        }), " ", uspItem)
    )), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Heading, {
        variant: "subheading2",
        component: "h5"
    }, labels.howToUseYourPolicy), /*#__PURE__*/ React.createElement(Card.Text, null, labels.howToUseYourPolicyDescription)), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Heading, {
        variant: "subheading2",
        component: "h5"
    }, labels.policyDetailsTitle), /*#__PURE__*/ React.createElement(Card.Text, null, labels.policyDetailsLink))));
};

export { InsurancePolicy };
//# sourceMappingURL=InsurancePolicy.js.map
